(function () {
  // Mobile Swiper for Media Grid
  if (typeof Swiper === 'undefined') return;

  function initForSection(sectionEl) {
    var grid = sectionEl.querySelector('.media-grid--grid');
    if (!grid) return;

    var isActive = grid.classList.contains('swiper-initialized');
    var breakpoint = 1024;

    function createSwiper() {
      // avoid double init
      if (grid._swiper) return;

      // wrap children in swiper-wrapper
      var wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      var children = Array.from(grid.children);
      children.forEach(function (child) {
        // skip if pagination element etc
        if (child.classList && child.classList.contains('swiper-pagination')) return;
        child.classList.add('swiper-slide');
        wrapper.appendChild(child);
      });

      // clear and append
      grid.innerHTML = '';
      grid.appendChild(wrapper);

      // add pagination to section container (outside grid)
      var sectionContainer = sectionEl.querySelector('.page--width, .page--width-full');
      var pagination = document.createElement('div');
      pagination.className = 'swiper-pagination';
      pagination.setAttribute('data-media-grid-pagination', '');
      if (sectionContainer) {
        sectionContainer.appendChild(pagination);
      } else {
        grid.appendChild(pagination);
      }

      // mark class
      grid.classList.add('swiper');

      // init swiper
      var swiper = new Swiper(grid, {
        slidesPerView: 1.05,
        spaceBetween: 12,
        centeredSlides: true,
        loop: false,
        pagination: {
          el: pagination,
          clickable: true
        }
      });

      grid._swiper = swiper;
      grid.classList.add('swiper-initialized');
    }

    function destroySwiper() {
      var swiper = grid._swiper;
      if (!swiper) return;
      try { swiper.destroy(true, true); } catch (e) { }

      // move slides back
      var wrapper = grid.querySelector('.swiper-wrapper');
      if (wrapper) {
        var slides = Array.from(wrapper.children);
        slides.forEach(function (slide) {
          slide.classList.remove('swiper-slide');
          grid.appendChild(slide);
        });
        wrapper.remove();
      }

      var pagination = sectionEl.querySelector('[data-media-grid-pagination]');
      if (pagination) pagination.remove();

      grid.classList.remove('swiper');
      grid.classList.remove('swiper-initialized');
      grid._swiper = null;
    }

    function adjustGridHeight() {
      if (window.innerWidth > breakpoint) {
        grid.style.height = 'auto'; // Temporarily allow growth
        var items = grid.querySelectorAll('.media-grid--item');
        var maxBottom = 0;
        var gridTop = grid.getBoundingClientRect().top;

        items.forEach(function (item) {
          var itemBottom = item.getBoundingClientRect().bottom;
          var relativeBottom = itemBottom - gridTop;
          if (relativeBottom > maxBottom) maxBottom = relativeBottom;
        });

        if (maxBottom > 0) {
          grid.style.height = 100 + Math.ceil(maxBottom) + 'px';
        }
      } else {
        grid.style.height = ''; // Let Swiper/CSS handle mobile
      }
    }

    function check() {
      if (window.innerWidth <= breakpoint && !grid._swiper) {
        createSwiper();
      } else if (window.innerWidth > breakpoint && grid._swiper) {
        destroySwiper();
      }
      adjustGridHeight();
    }

    // initial check
    check();

    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(check, 150);
    }

    window.addEventListener('resize', onResize);

    // store handler so we can remove later if needed
    sectionEl._mg_onResize = onResize;
  }

  function initAll() {
    var sections = document.querySelectorAll('.media-grid-section');
    sections.forEach(function (section) {
      initForSection(section);
    });
  }

  // init on DOM ready + when new sections are added (Shopify editor)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // When Shopify sections are re-rendered (editor), re-run init
  document.addEventListener('shopify:section:load', function (e) { initAll(); });
})();